import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user status is pending, redirect to pending approval page
  if (user?.status === 'pending' && location.pathname !== '/pending-approval') {
    return <Navigate to="/pending-approval" replace />;
  }

  // If user status is rejected, redirect to login
  if (user?.status === 'rejected') {
    return <Navigate to="/login" replace />;
  }

  // If user is approved but email not verified, redirect to email verification page
  if (user?.status === 'approved' && !user?.isEmailVerified && location.pathname !== '/verify-email-pending') {
    return <Navigate to="/verify-email-pending" replace />;
  }

  return children;
};

export default PrivateRoute;
